"use strict";

let $isRtl = $("html").attr("dir") === "rtl",
  countriesJson = {},
  CODE_OMAN = "omn";

// PATHS
let PATH = {
  IMG: vfo.country_flags_path,
  IMG_BUILD: "../build/img/",
  JSON: "../build/json/",
  COUNTRIES: vfo.countries_file,
  MAP: "https://vfo-corpp.zentity.com/coverage/Coverage_Sample.kml",
  MAPS: "https://vfo-corpp.zentity.com/coverage/Coverage_Sample",
};

// RESPONSIVE BREAKPOINTS
let BREAKPOINT = {
  LG: 1279,
  MD: 999,
  SM: 639,
  XS: 319,
};

function resetCountryCode(countries) {
  if (Object.values(countries).find((country) => country.iso === CODE_OMAN)) {
    return Object.values(countries).find((country) => country.iso === CODE_OMAN)
      .value;
  }
  return Object.values(countries)[0].value;
}

// init google map kml function
function initLayerMap() {
  const getMaps = document.getElementsByClassName("init-layer-map");

  for (var i = 0; i < getMaps.length; i++) {
    const mapItem = getMaps[i];

    const mapCoordinations = {
      lat: 23.257753,
      lng: 58.823688,
    };

    const map = new google.maps.Map(mapItem, {
      zoom: 6,
      mapTypeId: "terrain",
      center: mapCoordinations,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
    });

    new google.maps.KmlLayer(PATH.MAPS + (i === 0 ? "" : i + 1) + ".kml", {
      suppressInfoWindows: true,
      preserveViewport: false,
      map,
    });
  }
}

function plansCarousel(element = $(".carousel--plans")) {
  if (element.length) {
    element.slick({
      dots: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: '<div class="slick-arrow-custom arrow-prev"></div>',
      nextArrow: '<div class="slick-arrow-custom arrow-next"></div>',
      rtl: $isRtl,
      responsive: [
        {
          breakpoint: 1210,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: BREAKPOINT.SM + 1,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }
}

$(document).ready(function () {
  // -------------------------------
  // setLoading
  // -------------------------------

  function setLoading(element = "", appendLoaderHolder = false) {
    if (element && element.length && element[0]) {
      if (appendLoaderHolder) {
        // append element with lottie loader container if not exists
        if (!$(element).find("#loader").length) {
          $(element).append('<div id="loader"></div>');
        }
        if (!$(element).find("#loader svg").length) {
          lottie.loadAnimation({
            container: $(element).find("#loader")[0],
            path: `${PATH.JSON}loading.json`,
            renderer: "svg",
            loop: true,
            autoplay: true,
          });
        }
      } else {
        lottie.loadAnimation({
          container: element[0],
          path: `${PATH.JSON}loading.json`,
          renderer: "svg",
          loop: true,
          autoplay: true,
        });
      }
    }
  }

  //------------------------------------
  //  INVESTOR RELATIONS
  //------------------------------------
  $("#year").on("change", function (e) {
    let selectedValue = e.target.value,
      selectedText = e.target.innerText;

    $("#year-value").html(selectedText);
  });
  $("#report").on("change", function (e) {
    let selectedValue = e.target.value,
      selectedText = e.target.innerText;

    $("#report-value").html(selectedText);
  });

  //------------------------------------
  //  GET THE APP + GET A SIM + HOMEPAGE
  //------------------------------------
  if ($("#select-country, #select-country-modal").length) {
    let countryName = $isRtl ? "name_ar" : "name_en";

    // country options for select
    let countries = (function () {
      $.ajax({
        async: false,
        url: PATH.COUNTRIES,
        success: function (data) {
          countriesJson = JSON.stringify(data);
        },
      });

      return (
        countriesJson &&
        Object.values(JSON.parse(countriesJson))
          .sort(function (a, b) {
            return a.name_en < b.name_en ? -1 : a.name_en > b.name_en ? 1 : 0;
          })
          .map(function (jsonItem) {
            return Object.assign(jsonItem, {
              value: jsonItem.dial,
              customProperties: {
                ...jsonItem,
                dial: "+" + jsonItem.dial,
              },
            });
          })
      );
    })();

    // init countries choices.js select
    let $selectCountry;
    $("#select-country, #select-country-modal").each(function (index, item) {
      $selectCountry = new Choices(item, {
        searchEnabled: false,
        position: "botton",
        classNames: {
          containerOuter: Object.values($(item)[0].classList).join(" "),
        },
        choices: Object.values(countries),
        shouldSort: false,
        callbackOnCreateTemplates: function (template) {
          return {
            item: (classNames, data) => {
              return template(`
                <div class="${classNames.item} ${
                data.highlighted
                  ? classNames.highlightedState
                  : classNames.itemSelectable
              } ${
                data.placeholder ? classNames.placeholder : ""
              }" data-item data-id="${data.id}" data-value="${data.value}" ${
                data.active ? 'aria-selected="true"' : ""
              } ${data.disabled ? 'aria-disabled="true"' : ""}>
                  ${data.customProperties.dial}
                </div>
              `);
            },
            choice: function (classNames, data) {
              return template(`
                <div
                  class="${classNames.item} ${
                classNames.itemChoice
              } option option-country"
                  ${
                    data.disabled
                      ? classNames.itemDisabled
                      : classNames.itemSelectable
                  }" data-select-text="${
                this.config.itemSelectText
              }" data-choice ${
                data.disabled
                  ? 'data-choice-disabled aria-disabled="true"'
                  : "data-choice-selectable"
              } data-id="${data.id}" data-value="${data.value}" ${
                data.groupId > 0 ? 'role="treeitem"' : 'role="option"'
              }
                >
                    <svg>
                    <use xlink:href="${
                      PATH.IMG_BUILD
                    }sprite-countries.svg#icon-${
                data.customProperties.flag
              }"></use>
                    </svg>
                  <span class="option-country-value">
                    <span class="option-country__title">${
                      data.customProperties[countryName]
                    }</span>
                    <span class="option-country__number">${
                      data.customProperties.dial
                    }</span>
                  </span>
                </div>
              `);
            },
          };
        },
      });

      item.addEventListener("showDropdown", function (e) {
        const name = e.target.name;
        if (
          name &&
          $('[name="' + name + '"]')
            .closest(".form-group")
            .find("label").length
        ) {
          $('[name="' + name + '"]')
            .closest(".form-group")
            .find("label")
            .addClass("focus");
        }
      });
      item.addEventListener("hideDropdown", function (e) {
        const name = e.target.name;
        if (
          name &&
          $('[name="' + name + '"]')
            .closest(".form-group")
            .find("label").length
        ) {
          $('[name="' + name + '"]')
            .closest(".form-group")
            .find("label")
            .removeClass("focus");
        }
      });

      // // set default value
      $selectCountry.setChoiceByValue(resetCountryCode(countries));

      // set default value on custom event trigger
      document.addEventListener("country-reset", () => {
        $selectCountry.setChoiceByValue(
          // Oman code number
          resetCountryCode(countries)
        );
      });
    });

    $("#select-country-modal")
      .closest(".modal")
      .find(".close")
      .on("click", function () {
        // reset form => GET A SIM MODAL
        setTimeout(function () {
          $selectCountry.setChoiceByValue(resetCountryCode(countries));
        }, 150); // delay because of modal fade out
      });
  }

  //------------------------------------
  //  KHAREEF FORM
  //------------------------------------
  if ($("#select-nationality").length) {
    let countryName = $isRtl ? "name_ar" : "name_en";
    let countryNameEn = "name_en";

    // country options for select
    let countries = (function () {
      let countriesJson;
      $.ajax({
        async: false,
        url: PATH.COUNTRIES,
        success: function (data) {
          countriesJson = JSON.stringify(data);
        },
      });

      return (
        countriesJson &&
        Object.values(JSON.parse(countriesJson))
          .sort(function (a, b) {
            return a.name_en.localeCompare(b.name_en);
          })
          .map(function (jsonItem) {
            return {
              value: jsonItem[countryNameEn],
              label: jsonItem[countryName], // Use label to store the name
              customProperties: {
                dial: "+" + jsonItem.dial,
                flag: jsonItem.flag,
              },
              disabled: jsonItem.disabled || false,
            };
          })
      );
    })();

    // init countries choices.js select
    $("#select-nationality").each(function (index, item) {
      let $selectCountry = new Choices(item, {
        searchEnabled: false,
        position: "bottom", // Corrected typo here
        classNames: {
          containerOuter: Object.values($(item)[0].classList).join(" "),
        },
        choices: countries,
        shouldSort: false,
        callbackOnCreateTemplates: function (template) {
          return {
            item: (classNames, data) => {
              return template(`
              <div class="${classNames.item} ${
                data.highlighted
                  ? classNames.highlightedState
                  : classNames.itemSelectable
              } ${
                data.placeholder ? classNames.placeholder : ""
              }" data-item data-id="${data.id}" data-value="${data.value}" ${
                data.active ? 'aria-selected="true"' : ""
              } ${data.disabled ? 'aria-disabled="true"' : ""}>
                ${data.label}
              </div>
            `);
            },
            choice: (classNames, data) => {
              return template(`
              <div class="${classNames.item} ${
                classNames.itemChoice
              } option option-country ${
                data.disabled
                  ? classNames.itemDisabled
                  : classNames.itemSelectable
              }" data-select-text="${this.config.itemSelectText}" data-choice ${
                data.disabled
                  ? 'data-choice-disabled aria-disabled="true"'
                  : "data-choice-selectable"
              } data-id="${data.id}" data-value="${data.value}" ${
                data.groupId > 0 ? 'role="treeitem"' : 'role="option"'
              }
              >
                <svg>
                  <use xlink:href="${PATH.IMG_BUILD}sprite-countries.svg#icon-${
                data.customProperties.flag
              }"></use>
                </svg>
                <span class="option-country-value">
                  <span class="option-country__title">${data.label}</span>
                </span>
              </div>
            `);
            },
          };
        },
      });

      item.addEventListener("showDropdown", function (e) {
        $('[name="' + e.target.name + '"]')
          .closest(".form-group")
          .find("label")
          .addClass("focus");
      });
      item.addEventListener("hideDropdown", function (e) {
        $('[name="' + e.target.name + '"]')
          .closest(".form-group")
          .find("label")
          .removeClass("focus");
      });

      // Function to reset country code
      function resetCountryCode(countries) {
        // Assuming Oman's code or a default value needs to be set, adjust accordingly
        let defaultCountry = countries.find(
          (country) => country.customProperties.dial === "+968"
        ); // example for Oman
        return defaultCountry ? defaultCountry.value : "";
      }

      // set default value
      $selectCountry.setChoiceByValue(resetCountryCode(countries));

      // set default value on custom event trigger
      document.addEventListener("country-reset", () => {
        $selectCountry.setChoiceByValue(resetCountryCode(countries));
      });
    });
  }

  //------------------------------------
  //  ROAMING AUTOSUGGEST
  //------------------------------------
  //------------------------------------
  //  ROAMING AUTOSUGGEST
  //------------------------------------
  if ($("#roaming_country").length) {
    let roamingContent = $(".roaming-form-content"),
      roamingPageContent = $(".roaming-form-page-content"),
      roamingZonesPageContent = $("#roaming-zones-form-page-content"),
      selectedCountryIsoCodes = [];
    $(".roaming-form").on("submit", function (e) {
      e.preventDefault();
    });

    // country object for autosuggest
    let countries = (function () {
      $.ajax({
        async: false,
        url: vfoAjax.apiUrl + "/roaming_countries/",
        data: {
          lang: $isRtl ? "ar" : "en",
        },
        success: function (result) {
          countriesJson = result;
        },
      });

      return (
        countriesJson &&
        Object.values(JSON.parse(countriesJson)).map(function (jsonItem) {
          return Object.assign(jsonItem, {
            data: jsonItem.iso,
            value: jsonItem.name,
          });
        })
      );
    })();

    let autocompleteCountries = [];
    $("#roaming_country").autocomplete({
      lookup: countries,
      triggerSelectOnValidInput: false,
      autoSelectFirst: true,
      appendTo: $("#roaming_country").closest(".form-group"),
      beforeRender: function (container, suggestions) {
        autocompleteCountries = suggestions;
      },
      formatResult: function (suggestion) {
        return suggestion.value;
      },
      onSelect: function (suggestion) {
        // -------------------------------------------------
        // ON ROAMING COUNTRY AUTOSUGGEST SELECT HANDLER
        // -------------------------------------------------
        roamingContent.html("");
        $("#roaming_country_search")
          .removeClass("active")
          .attr("disabled", true);

        // append element with lottie loader container if not exists
        if (roamingPageContent.length) {
          if (selectedCountryIsoCodes.length === 0) {
            roamingPageContent.html("");
            setLoading(roamingPageContent, true);
          } else {
            const roamingPageAccordion =
              $(roamingPageContent).find(".accordion");
            setLoading(roamingPageAccordion, true);
          }
        }

        // roaming popup
        if ($("#roamingModal").length) {
          $(".roaming-bigtable__header")
            .removeClass("d-sm-flex")
            .addClass("d-none");
          $(".tlw--roaming-popup--btn").addClass("d-none");

          setLoading(roamingContent, true);

          var ajaxUrl =
            vfoAjax.apiUrl +
            "/generate_markup_roaming_popup/" +
            vfoAjax.currentLang;
          $.ajax({
            url: ajaxUrl,
            method: "GET",
            dataType: "text",
            data: {
              country_iso: suggestion.iso,
              country_name: suggestion.value,
              lang: $isRtl ? "ar" : "en",
            },
            success: function (response) {
              lottie.destroy(); // destroy lottie loader

              roamingContent.html(response);
              $(".roaming-bigtable__header")
                .removeClass("d-none")
                .addClass("d-sm-flex");
              $(".tlw--roaming-popup--btn").removeClass("d-none");
            },
            error: function () {
              lottie.destroy(); // destroy lottie loader
            },
          });
        }

        // -------------------------------------------------
        // get all selected countries from autosuggest => ROAMING PAGE
        // -------------------------------------------------
        if (
          selectedCountryIsoCodes.length &&
          !selectedCountryIsoCodes.find(function (item) {
            return item === suggestion.iso;
          })
        ) {
          selectedCountryIsoCodes.push(suggestion.iso);
        } else if (!selectedCountryIsoCodes.length) {
          selectedCountryIsoCodes.push(suggestion.iso);
        }

        // -------------------------------------------------
        // remove autossugest input value on select country
        // -------------------------------------------------
        if (!$("#roaming_country").hasClass("clear-on-select")) {
          $("#roaming_country").val("");
          $("#roaming_country_clear").hide();
          $("#roaming_country_search").removeClass("active");
        }

        // select first tab type
        if ($("#pills-tab")) {
          $("#pills-tab")
            .children()
            .each(function (pillIndex, pillItem) {
              if (pillIndex === 0) {
                $(pillItem).children().tab("show");
              }
            });
        }

        if ($("body").hasClass("page--international-calls")) {
          if (
            selectedCountryIsoCodes.length &&
            !selectedCountryIsoCodes.find(function (item) {
              return item === suggestion.iso;
            })
          ) {
            selectedCountryIsoCodes.push(suggestion.iso);
          } else if (!selectedCountryIsoCodes.length) {
            selectedCountryIsoCodes.push(suggestion.iso);
          }

          // -------------------------------------------------
          // APPEND RESPONSE DATA => ROAMING PAGE
          // -------------------------------------------------
          roamingPageRender();

          // do not forget to reinitialize plans (roaming) carousel on append data
          //plansCarousel();
        }

        if ($("body").hasClass("page--roaming-zones")) {
          selectedCountryIsoCodes = [suggestion.iso];

          // -------------------------------------------------
          // APPEND RESPONSE DATA => ROAMING ZONES PAGE
          // -------------------------------------------------
          roamingZonesPageRender();
        }

        // do not forget to reinitialize plans (roaming) carousel on append data
        //plansCarousel();
      },
    });

    // render roaming page
    function roamingPageRender(selectedCountry = undefined) {
      var ajaxUrl =
        vfoAjax.apiUrl + "/generate_markup_roaming/" + vfoAjax.currentLang;
      $.ajax({
        url: ajaxUrl,
        method: "GET",
        dataType: "text",
        data: {
          country_iso_codes: selectedCountry
            ? [selectedCountry]
            : selectedCountryIsoCodes,
          lang: $isRtl ? "ar" : "en",
        },
        success: function (response) {
          lottie.destroy(); // destroy lottie loader

          roamingPageContent.html(response);
          $(".roaming-search-headline")
            .removeClass("d-none")
            .addClass("d-flex");
          $(".roaming-bigtable__header")
            .removeClass("d-none")
            .addClass("d-sm-flex");

          // do not forget to reinitialize plans (roaming) carousel on append data
          plansCarousel();
        },
        error: function () {
          lottie.destroy(); // destroy lottie loader
        },
      });
    }

    // -------------------------------------------------
    // RENDER DEFAULT ROAMING + ROAMING ZONES
    // -------------------------------------------------
    function roamingPageRenderDefault() {
      if ($("body").hasClass("page--international-calls")) {
        $(".roaming-bigtable__header")
          .removeClass("d-sm-flex")
          .addClass("d-none");

        setLoading(roamingPageContent, true);

        var ajaxUrl =
          vfoAjax.apiUrl + "/generate_markup_roaming/" + vfoAjax.currentLang;
        $.ajax({
          url: ajaxUrl,
          method: "GET",
          dataType: "text",
          data: {
            default: true,
            lang: $isRtl ? "ar" : "en",
          },
          success: function (response) {
            lottie.destroy(); // destroy lottie loader

            roamingPageContent.html(response);
            $(".roaming-bigtable__header")
              .removeClass("d-none")
              .addClass("d-sm-flex");

            // do not forget to reinitialize plans (roaming) carousel on append data
            plansCarousel();
          },
          error: function () {
            lottie.destroy(); // destroy lottie loader
          },
        });
      }

      if ($("body").hasClass("page--roaming-zones")) {
        setLoading(roamingZonesPageContent, true);

        var ajaxUrl = vfoAjax.apiUrl + "/roaming/" + vfoAjax.currentLang;
        $.ajax({
          url: ajaxUrl,
          method: "GET",
          dataType: "text",
          data: {
            default: true,
            lang: $isRtl ? "ar" : "en",
          },
          success: function (response) {
            lottie.destroy(); // destroy lottie loader

            roamingZonesPageContent.html(response);
          },
          error: function () {
            lottie.destroy(); // destroy lottie loader
          },
        });
      }
    }
    roamingPageRenderDefault();

    // -------------------------------------------------
    // RENDER ROAMING ZONES
    // -------------------------------------------------
    function roamingZonesPageRender(selectedCountry = undefined) {
      roamingZonesPageContent.html("");

      setLoading(roamingZonesPageContent, true);

      var ajaxUrl = vfoAjax.apiUrl + "/roaming/" + vfoAjax.currentLang;
      $.ajax({
        url: ajaxUrl,
        method: "GET",
        dataType: "text",
        data: {
          country_iso_codes: selectedCountry
            ? [selectedCountry]
            : selectedCountryIsoCodes,
          lang: $isRtl ? "ar" : "en",
        },
        success: function (response) {
          lottie.destroy(); // destroy lottie loader

          roamingZonesPageContent.html(response);
        },
        error: function () {
          lottie.destroy(); // destroy lottie loader
        },
      });
    }

    // SEARCH on romaming form button click
    $("#roaming_country_search").on("click", function () {
      if (autocompleteCountries.length) {
        if ($("body").hasClass("page--international-calls")) {
          $("#roaming_country").val("");
          roamingPageRender(autocompleteCountries[0].iso);
        }

        if ($("body").hasClass("page--roaming-zones")) {
          $("#roaming_country").val(autocompleteCountries[0].value);
          roamingZonesPageRender(autocompleteCountries[0].iso);
        }

        $("#roaming_country_search")
          .removeClass("active")
          .attr("disabled", true);
      }
    });

    // SHOW/HIDE autossugest clear button
    $("#roaming_country").on("change keydown paste input", function () {
      if ($("#roaming_country").val()) {
        $("#roaming_country_clear").show();
        $("#roaming_country_search").addClass("active").attr("disabled", false);
      } else {
        $("#roaming_country_clear").hide();
        $("#roaming_country_search")
          .removeClass("active")
          .attr("disabled", true);
      }
    });

    // REMOVE ROAMING COUNTRY SELECTED VALUE HANDLER
    $("#roaming_country_clear").click(function () {
      $("#roaming_country").val("");
      $("#roaming_country").autocomplete().clear();
      $("#roaming_country_clear").hide();
      $("#roaming_country_search").removeClass("active").attr("disabled", true);
      $(".tlw--roaming-popup--btn").addClass("d-none");
      roamingContent.html("");
      roamingZonesPageContent.html("");
      roamingPageRenderDefault();
    });

    // REMOVE SELECTED ROAMING COUNTRY TABLE ITEM
    $(document).on("click", ".roaming-bigtable-item-delete", function (e) {
      e.stopPropagation();
      const elId = $(this).attr("data-id");
      if ($("#pills-tab").length) {
        const tabsLenght = $("#pills-tab").children().length;
        for (let i = 0; i < tabsLenght; i++) {
          $(`#roaming-bigtable-item-${i}-${elId}`).remove();
        }
      }

      // REMOVE COUNTRY ITEM FROM ARRAY OF SELECTED COUNTRIES HANDLER
      selectedCountryIsoCodes = selectedCountryIsoCodes.filter(function (item) {
        return item !== elId;
      });

      // render roaming template
      if (!selectedCountryIsoCodes.length) {
        $(".roaming-search-headline").removeClass("d-flex").addClass("d-none");
        roamingPageContent.html("");
        roamingPageRenderDefault();
      } else {
        roamingPageRender();
      }

      // select first tab type
      if ($("#pills-tab")) {
        $("#pills-tab")
          .children()
          .each(function (pillIndex, pillItem) {
            if (pillIndex === 0) {
              $(pillItem).children().tab("show");
            }
          });
      }
    });
  }

  // privacy policy
  // hash response in url
  if ($("body").hasClass("page--privacy-policy")) {
    $(function () {
      var hash = window.location.hash;
      if (hash.length != 0) {
        var hashText = hash.substring(hash.indexOf("#") + 1);
        var hashID = $(".nav-link." + hashText).attr("href");
        hashID && $('ul.nav a[href="' + hashID + '"]').tab("show");
        $("html, body").animate(
          {
            scrollTop: $(".section--grey-dark").offset().top - 100,
          },
          2000
        );
      }

      $("#pills-tab a").click(function (e) {
        $(this).tab("show");
        var classText = $(this).attr("class");
        var classExplode = classText.split(" ");
        var hash = "#" + classExplode[1];
        window.location.hash = hash;
        $("html, body").animate(
          {
            scrollTop: $(".section--grey-dark").offset().top - 100,
          },
          2000
        );
      });
    });
  }

  // -------------------------------
  // FAQ - show subtopics content on click
  // -------------------------------
  $(".box--sub").click(function () {
    let subboxId = $(this).attr("data-subbox-id");
    let subbox = $(this)
      .closest(".boxes--simple-row")
      .next(".subboxes")
      .find("#" + subboxId);
    let subboxWrapper = $(this)
      .closest(".boxes--simple-row")
      .next(".subboxes")
      .find("#" + subboxId)
      .find(".subbox__content");
    let child_key = subboxWrapper.attr("data-subbox-id");
    let child_slug = subboxWrapper.attr("data-subbox-cat-slug");
    var child_status = subboxWrapper.attr("data-subbox-status");

    if (child_status == "false") {
      subboxWrapper.html("");
      setLoading(subboxWrapper);
    }

    $(this)
      .closest(".boxes--simple-row")
      .hide()
      .prev(".boxes__navigation")
      .addClass("boxes__navigation--active");
    $(this).closest(".boxes--simple-row").hide().next(".subboxes").fadeIn();
    subbox.show().siblings().hide();

    if (child_status == "false") {
      var ajaxUrl =
        vfoAjax.apiUrl + "/generate_faq_data/" + vfoAjax.currentLang;
      $.ajax({
        url: ajaxUrl,
        method: "GET",
        dataType: "text",
        data: {
          slug: child_slug,
          key: child_key,
        },
        success: function (response) {
          subboxWrapper.html(response);
          subboxWrapper.attr("data-subbox-status", true);
        },
      });
    }
  });

  // ------------------------------------------ MEDIA CENTRE ------------------------------------------ //

  //------------------------------------
  //  MEDIA CENTRE - HELPERS
  //------------------------------------
  const mediaShowMoreButton = $(document).find(".media-show-more button");
  let searchMediaPage = 1;

  function toggleMediaShowMoreBtn(show = false) {
    $(mediaShowMoreButton).css("display", show ? "block" : "none");
  }

  function disableSearchIcon(disabled) {
    const mediaSearchIcon = $(document).find("#media_search_icon");
    if (disabled) {
      return mediaSearchIcon.attr("disabled", disabled).removeClass("active");
    }
    return mediaSearchIcon.attr("disabled", disabled).addClass("active");
  }

  const monthPlaceholder = {
    value: "0",
    label: $isRtl ? "Ø´Ù‡Ø±" : "Month",
    placeholder: true,
  };

  //------------------------------------
  //  MEDIA CENTRE - SEARCH
  //------------------------------------
  $(document).keyup("#media_search", function (e) {
    const mediaSearchValue = $(this).find("#media_search").val();

    if (e.key === "Enter") {
      return;
    }
    if (mediaSearchValue === "") {
      $("#media_search_clear").hide();
      loadPosts();
      return disableSearchIcon(true);
    }
    $("#media_search_clear").show();
    return disableSearchIcon(false);
  });

  $(document)
    .find(".media-search-form")
    .submit(function (e) {
      e.preventDefault();

      const mediaSearchValue = $(document).find("#media_search").val(),
        mediaItemsHolder = $(document).find(".media-items");

      searchMediaPage = 1;

      toggleMediaShowMoreBtn(false);
      disableSearchIcon(true);

      mediaItemsHolder.children().remove();
      setLoading(mediaItemsHolder);

      // AJAX CALL
      loadPosts();
    });

  //------------------------------------
  //  MEDIA CENTRE - CLEAR SEARCH
  //------------------------------------
  $(document)
    .find("#media_search_clear")
    .on("click", function () {
      const mediaItemsHolder = $(document).find(".media-items");

      searchMediaPage = 1;

      $("#media_search_clear").hide();
      $("#media_search").val("");
      toggleMediaShowMoreBtn(false);
      disableSearchIcon(true);

      mediaItemsHolder.children().remove();
      setLoading(mediaItemsHolder);

      // AJAX CALL
      loadPosts();
    });

  //------------------------------------
  //  MEDIA CENTRE - SHOW MORE
  //------------------------------------
  mediaShowMoreButton.on("click", function () {
    const mediaSearchValue = $(document).find("#media_search").val(),
      mediaItemsHolder = $(document).find(".media-items"),
      hasSelectedYearAndMonth =
        ($("#media_year")[0].value !== "year" &&
          $("#media_month")[0].value !== "month") ||
        undefined,
      search = $("input.js-post-filter-fulltext").val(),
      year = $("select.js-post-filter-year").val(),
      month = $("select.js-post-filter-month").val();

    searchMediaPage = searchMediaPage + 1;

    setLoading(mediaShowMoreButton);
    $(mediaShowMoreButton).attr("disabled", true).addClass("btn--loading");
    disableSearchIcon(true);

    // AJAX CALL
    $.ajax({
      url: vfoAjax.apiUrl + "/posts/" + vfoAjax.currentLang,
      method: "GET",
      dataType: "json",
      data: {
        paged: searchMediaPage,
        search: search,
        year: year,
        month: month,
      },
      success: function (response) {
        mediaItemsHolder.append(response.data.html);
      },
      complete: function (data) {
        disableSearchIcon(mediaSearchValue === "");
        $(mediaShowMoreButton)
          .attr("disabled", false)
          .removeClass("btn--loading")
          .find("svg")
          .remove();
        toggleMediaShowMoreBtn(
          data.responseJSON.success && data.responseJSON.data.has_remain_posts
        );
      },
    });
  });

  //------------------------------------
  //  MEDIA CENTRE - FILTER - YEAR
  //------------------------------------
  let $selectMediaYear;
  // init year select
  $("#media_year").each(function (index, item) {
    $selectMediaYear = new Choices(item, {
      searchEnabled: false,
      position: "bottom",
      classNames: {
        containerOuter: Object.values($(item)[0].classList).join(" "),
      },
      shouldSort: false,
    });
  });

  // handle on year change
  $("#media_year").on("change", function (e) {
    // month select loading
    const mediaMonthList = $("#media_month").next(".choices__list");
    setLoading(mediaMonthList);
    mediaMonthList.addClass("choices__list--loading");

    const mediaItemsHolder = $(document).find(".media-items");
    mediaItemsHolder.empty();
    setLoading(mediaItemsHolder);

    $selectMediaMonth.disable();

    $.ajax({
      url: vfoAjax.apiUrl + "/post_months/" + vfoAjax.currentLang,
      method: "GET",
      data: {
        year: e.target.value,
      },
      success: function (response) {
        $selectMediaMonth
          .clearChoices() // this method prevents options duplication
          .setValue([
            ...response,
            monthPlaceholder, // has to be the last option
          ])
          .enable();
      },
      complete: function () {
        $selectMediaMonth.enable();

        // stop month select loading
        mediaMonthList
          .removeClass("choices__list--loading")
          .find("svg")
          .remove();

        searchMediaPage = 1;

        loadPosts();
      },
    });
  });

  //------------------------------------
  //  MEDIA CENTRE - FILTER - MONTH
  //------------------------------------
  let $selectMediaMonth;
  // init month select
  $("#media_month").each(function (index, item) {
    $selectMediaMonth = new Choices(item, {
      searchEnabled: false,
      position: "botton",
      classNames: {
        containerOuter: Object.values($(item)[0].classList).join(" "),
      },
      shouldSort: false,
    });
  });

  // setup month options
  if ($("#media_month").length) {
    $selectMediaMonth
      .setValue([monthPlaceholder]) // DEFAULT PLACEHOLDER OPTION
      .disable();
  }

  // handle on month change
  $("#media_month").on("change", function (e) {
    const mediaItemsHolder = $(document).find(".media-items");

    searchMediaPage = 1;

    mediaItemsHolder.empty();
    setLoading(mediaItemsHolder);

    toggleMediaShowMoreBtn(false);
    disableSearchIcon(true);

    loadPosts();
  });

  function loadPosts() {
    const mediaItemsHolder = $(document).find(".media-items"),
      search = $("input.js-post-filter-fulltext").val(),
      year = $("select.js-post-filter-year").val(),
      month = $("select.js-post-filter-month").val();

    $.ajax({
      url: vfoAjax.apiUrl + "/posts/" + vfoAjax.currentLang,
      method: "GET",
      dataType: "json",
      data: {
        search: search,
        year: year,
        month: month,
      },
      success: function (response) {
        mediaItemsHolder.html(response.data.html);
      },
      complete: function (data) {
        disableSearchIcon(false);
        toggleMediaShowMoreBtn(
          data.responseJSON.success && data.responseJSON.data.has_remain_posts
        );
      },
    });
  }

  // ------------------------------------------ MEDIA CENTRE ------------------------------------------ //
});

$(document).on("DOMNodeInserted", function (e) {
  var carouselWrapper = $(e.target).find(".js-carousel-wrapper");
  if ($("body").hasClass("compose-mode") && carouselWrapper.length) {
    plansCarousel(carouselWrapper.find(".carousel"));
  }
});
